import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { Storage } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("STORAGE_MODULE");

export const moduleActions = createDataModuleActions<Storage>(actionCreator);
export const getStorageTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const storageActions = {
  ...normalizeActions(moduleActions.data),
};
export const storageActionCreators = {
  ...moduleActions,
};
